module.exports = __webpack_public_path__ + "img/lens-150-minus-02.c64d1697.png";